__webpack_require__.p = "/realtime-events-header/referrals-hub/";